import { QuickAssessment } from "./QuickAssessment";

export default {
  QuickAssessment,
};
